import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * Handles scroll restoration on route changes:
 * - Scrolls to top when navigating to a new page (no hash)
 * - Scrolls to hash anchor element when URL contains a hash
 * 
 * This ensures users always start at the correct position when navigating,
 * preventing the browser from preserving scroll position from previous pages.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // URL contains a hash anchor - scroll to that element
      // Delay ensures page content is fully rendered before scrolling
      const elementId = hash.replace('#', '');
      const scrollToElement = () => {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };
      
      // Small delay to ensure DOM is ready
      const timeoutId = setTimeout(scrollToElement, 100);
      return () => clearTimeout(timeoutId);
    } else {
      // No hash - scroll to top of page
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
